import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { filterDOMProps } from '@react-aria/utils';
import React, { forwardRef, useContext } from 'react';
import { SelectStateContext, TextContext, SelectValueContext, SelectContext } from 'react-aria-components';
import { selectedKeyToNode } from '../../collections/aria/collection.esm.js';
import { useContextProps, useSlottedContext, useRenderProps } from '../../utils/index.esm.js';

function SelectValue(props, ref) {
  var _ref2, _state$selectedItem, _state$selectedItem$t, _state$selectedItem2;
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  var _useContextProps = useContextProps(props, ref, SelectValueContext);
  var _useContextProps2 = _slicedToArray(_useContextProps, 2);
  props = _useContextProps2[0];
  ref = _useContextProps2[1];
  var state = useContext(SelectStateContext);
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  var _ref = useSlottedContext(SelectContext),
    placeholder = _ref.placeholder;
  var selectedItem = selectedKeyToNode(state.selectedKey, state.collection);
  var isMultiple = Array.isArray(selectedItem);

  // *** original single select mode handling [begin] ***
  var rendered = !isMultiple ? selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.rendered : undefined;
  if (typeof rendered === 'function') {
    // If the selected item has a function as a child, we need to call it to render to React.JSX.
    var fn = rendered;
    rendered = fn({
      isHovered: false,
      isPressed: false,
      isSelected: false,
      isFocused: false,
      isFocusVisible: false,
      isDisabled: false,
      selectionMode: isMultiple ? 'multiple' : 'single',
      selectionBehavior: 'toggle'
    });
  }
  // *** original single select mode handling [end] ***

  var renderProps = useRenderProps(_objectSpread2(_objectSpread2({}, props), {}, {
    defaultChildren: isMultiple && props.renderSelectItems ? props.renderSelectItems(selectedItem) || placeholder : rendered || placeholder,
    defaultClassName: 'react-aria-SelectValue',
    values: {
      selectedItem: (_ref2 = (_state$selectedItem = state.selectedItem) === null || _state$selectedItem === void 0 ? void 0 : _state$selectedItem.value) !== null && _ref2 !== void 0 ? _ref2 : null,
      selectedText: (_state$selectedItem$t = (_state$selectedItem2 = state.selectedItem) === null || _state$selectedItem2 === void 0 ? void 0 : _state$selectedItem2.textValue) !== null && _state$selectedItem$t !== void 0 ? _state$selectedItem$t : null,
      isPlaceholder: !selectedItem
    }
  }));
  var DOMProps = filterDOMProps(props);
  return /*#__PURE__*/React.createElement("span", _extends({
    ref: ref
  }, DOMProps, renderProps, {
    "data-placeholder": !selectedItem || undefined
  }), /*#__PURE__*/React.createElement(TextContext.Provider, {
    value: undefined
  }, renderProps.children));
}

/**
 * SelectValue renders the current value of a Select, or a placeholder if no value is selected.
 * It is usually placed within the button element.
 */
var _SelectValue = /*#__PURE__*/forwardRef(SelectValue);

export { _SelectValue as default };
//# sourceMappingURL=select-value.esm.js.map
